import { hiddenField, stringField } from 'common/utils/form/fieldTypes';

const config = {
  id: hiddenField(),
  organization: stringField({ required: true })
};

export default config;
